module.exports = __webpack_public_path__ + "static/media/Arbeitszimmer_6.924583fc.png";